import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { createApi } from '@fortem-monorepo/web-sdk';
const apiContext = React.createContext(null);
export const ApiProvider = ({ clientOptions = {}, children }) => {
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();
    const getToken = React.useCallback(async () => {
        if (!isAuthenticated)
            return null;
        return getAccessTokenSilently();
    }, [getAccessTokenSilently, isAuthenticated]);
    const api = React.useMemo(() => {
        return createApi({
            ...clientOptions,
            getToken,
        });
    }, [clientOptions, getToken]);
    return _jsx(apiContext.Provider, { value: api, children: children });
};
export const useApi = () => {
    const context = React.useContext(apiContext);
    if (!context) {
        throw new Error('useApi must be used within an ApiProvider');
    }
    return context;
};
